module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_Overview-Rear_1.3f615ad7.jpg";